module.exports = __webpack_public_path__ + "img/全景智联机场大数据分析应用平台.b41cee46.jpg";